const News = {
  data: null,
  result: null,
  error: null,

  fetch: (options={}) => {
    return m.request({
      method: "GET",
      url: "/news/",
    }).then(result => {
      News.result = result.rss.channel
      News.data = result.rss.channel.item
      return News.data
    }).catch(e => {
      News.error = e.message
      return e
    })
  }
}

export { News }
